import { memo, useState } from "react";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import SegmentedControlCreatorFragment from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/SegmentedControlCreatorFragment/SegmentedControlCreatorFragment";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";

function SegmentedControlCreatorFragmentDemo() {
  const [task, setTask] = useState<Record<string, unknown>>({
    details: { control: "option1" },
  });
  const [field, setField] = useState("details.control");

  const configProps = {
    field,
    items: [
      { value: "option1", label: "Option 1" },
      { value: "option2", label: "Option 2" },
      { value: "option3", label: "Option 3" },
    ],
  };

  const commonProps = {
    task,
    onTaskChange: (part: Record<string, unknown>) =>
      setTask((prev) => ({ ...prev, ...part })),
    blockInput: false,
    showValidation: false,
    taskType: { details: [] } as any,
  };

  return (
    <Demo>
      <Name>SegmentedControlCreatorFragment</Name>
      <Highlight>
        <FixaListView id="segmentedcontroldemo" size="small">
          <SegmentedControlCreatorFragment
            configProps={configProps}
            commonProps={commonProps}
          />
        </FixaListView>
      </Highlight>
      <Actions>
        <FixaInputField
          label="field"
          type="text"
          id="segmentedcontrol-field"
          value={field}
          onChange={(e) => setField(e.target.value)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(SegmentedControlCreatorFragmentDemo);
